import type { SapConnectionRepository } from '@/domain/repositories/sap-connection-repository.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { SapConnectionRepositoryImpl } from '@/infra/repositories/sap-connection-repository-impl.js';

export const makeSapConnectionRepository = (httpClient: FetchHttpClient): SapConnectionRepository => new SapConnectionRepositoryImpl(httpClient);
